export default __webpack_public_path__ + "static/media/Scentpad-orient.4b8152ad.jpg";